<template>
  <div>
    <v-container id="search-container">
      <!--//@*/*
    //    *RPD  App v0.91
    //    * Copyright (c) 2022, Blue Cover Six LLC .John Molt All rights reserved.
    //    Code licensed under contract To Reno Police Department / City of Reno, in perpetuity
    //    */
    //-->
      <v-form v-model="valid" lazy-validation>
        <v-row dense>
          <p class="mb-0 font-weight-bold">
            Enter search criteria. No criteria returns ALL records (may take a
            little while)
          </p>
        </v-row>

        <v-row dense>
          <v-col cols="6" class="sel-int-col-100">
            <!-- <v-text-field
              v-mask="'##/##/####'"
              placeholder="##/##/####"
              v-model="sterm.frm_date"
              label="From Date"
              :rules="daterule"
            ></v-text-field> -->
            <label>From&nbsp;Date</label>
            <select v-model="sterm.frm_date">
              <option v-for="dy in days" :key="dy" :value="dy">
                {{ dy }}
              </option>
            </select>
          </v-col>
          <v-col cols="6" class="sel-int-col-100">
            <!-- <v-text-field
              placeholder="##/##/####"
              v-mask="'##/##/####'"
              v-model="sterm.to_date"
              label="To Date"
              :rules="daterule"
            ></v-text-field> -->
            <label>To&nbsp;Date</label>
            <select v-model="sterm.to_date">
              <option v-for="dy in days" :key="dy" :value="dy">
                {{ dy }}
              </option>
            </select>
          </v-col>
        </v-row>
        <v-row dense>
          <v-col cols="12">
            <p class="my-0 font-weight-bold">Filter by</p>
          </v-col>
        </v-row>
        <v-row class="mt-0 pt-0">
          <v-col cols="12" class="my-0 py-0">
            <v-autocomplete
              v-model="sterm.email"
              :items="lst_email"
              label="Records created by"
            ></v-autocomplete>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <v-select
              v-model="sterm.stop_type"
              :items="types"
              label="Type"
              required
              background-color="#ECEFF1"
            ></v-select>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <v-select
              v-model="sterm.grant"
              :items="grants"
              label="Grants"
              background-color="#ECEFF1"
            >
              <template v-slot:item="slotProps">
                {{ slotProps.item }}
              </template>
            </v-select>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12">
            <v-text-field
              placeholder=""
              v-model="sterm.location"
              label="Location Decription"
            ></v-text-field>
          </v-col>
        </v-row>

        <v-row dense no-gutters>
          <!-- Cites -->
          <v-col cols="6" md="3">
            <v-checkbox
              class="mt-0"
              v-model="sterm.cites"
              label="Cites"
            ></v-checkbox>
          </v-col>
          <!-- stops -->
          <v-col cols="6" md="3">
            <v-checkbox
              class="mt-0"
              v-model="sterm.deeds"
              label="Deeds"
            ></v-checkbox>
          </v-col>
          <!-- CFS -->
          <v-col cols="6" md="3">
            <v-checkbox
              class="mt-0"
              v-model="sterm.cfs"
              label="CFS"
            ></v-checkbox>
          </v-col>
          <!-- arrest -->
          <v-col cols="6" md="3">
            <v-checkbox
              class="mt-0"
              v-model="sterm.arrest"
              label="Arrest"
            ></v-checkbox>
          </v-col>
        </v-row>
        <v-row dense no-gutters>
          <!-- DUI -->
          <v-col cols="6" md="3">
            <v-checkbox
              class="mt-0"
              v-model="sterm.dui"
              label="DUI"
            ></v-checkbox>
          </v-col>
          <!-- accident -->
          <v-col cols="6" md="3">
            <v-checkbox
              class="mt-0"
              v-model="sterm.accident"
              label="Accident"
            ></v-checkbox>
          </v-col>
          <!-- SRO -->
          <v-col cols="6" md="3">
            <v-checkbox
              class="mt-0"
              v-model="sterm.sro"
              label="SRO"
            ></v-checkbox>
          </v-col>
          <!-- MAIT -->
          <v-col cols="6" md="3">
            <v-checkbox
              class="mt-0"
              v-model="sterm.mait"
              label="MAIT"
            ></v-checkbox>
          </v-col>
        </v-row>

        <!-- stops -->

        <div
          style="width: 100%; display: flex !important"
          class="d-felx flex-row justify-center"
        >
          <v-checkbox
            style="width: 87px"
            class="mt-0"
            v-model="sterm.stops"
            label="Stops"
          ></v-checkbox>
        </div>

        <v-row dense no-gutters>
          <v-col cols="12" md="12">
            <!-- viusible only on phones -->
            <div class="hide-if-large d-flex justify-space-around align-start">
              <div style="margin-top: 21px; width: 135px; text-align: center">
                Any terms Above
              </div>
              <v-switch v-model="sterm.all" label=""></v-switch>
              <div style="margin-top: 21px; width: 135px; text-align: center">
                Only Terms Above
              </div>
            </div>
            <!-- visble on everything but phones -->
            <div class="hide-if-small d-flex justify-center align-start">
              <div style="margin-top: 21px; width: 135px; text-align: center">
                Any terms Above
              </div>
              <v-switch v-model="sterm.all" label=""></v-switch>
              <div style="margin-top: 21px; width: 135px; text-align: center">
                Only Terms Above
              </div>
            </div>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" class="d-flex justify-space-between">
            <v-btn
              color="cmpbk"
              class="mr-4 white--text"
              @click.prevent="search"
            >
              Search
            </v-btn>
            <v-btn color="cmpbk" class="mr-4 white--text" @click="reset">
              Clear Form
            </v-btn>
          </v-col>
        </v-row>
      </v-form>
    </v-container>
  </div>
</template>

<style lang="scss" scoped>
@import "../scss/site.scss";
#chk-all.v-icon.v-icon {
  color: white !important;
}
@media (min-width: 0px) {
  .hide-if-small {
    display: none !important;
  }
  // .hide-if-large {
  //   display: none !important;
  // }
  .sel-int-col-100 {
    width: 100%;
    // height: 55px;
    // position: relative;
    // top: -25px;
  }

  .sel-int-col-100 select {
    width: 100%;
    color: blue;
    outline: 1px solid black;
    height: 45px;
    font-size: 18px;
    padding-left: 5px;
    margin-left: 10px;
    // position: relative;
    // top: 10px;
  }
}

/* 768 media q */
@media (min-width: 768px) {
  .hide-if-small {
    display: flex !important;
  }
  .hide-if-large {
    display: none !important;
  }
  .sel-int-col-100 {
    width: 100%;
    // height: 55px;
    // position: relative;
    // top: -25px;
  }

  .sel-int-col-100 select {
    width: 40%;
    color: blue;
    outline: 1px solid black;
    height: 45px;
    font-size: 18px;
    padding-left: 5px;
    margin-left: 10px;
    // position: relative;
    // top: 10px;
  }
}
select {
  -webkit-appearance: listbox !important;
  appearance: listbox !important;
}
</style>

<script>
/* eslint-disable */
import { bus_common } from "../mixins/bus_common";
export default {
  name: "search",
  mixins: [bus_common],
  props: ["update_search_results", "lst_grants"],
  data() {
    return {
      lst_email: [],
      values: [],
      lst_users: [],
      bReady_to_update: false,
      valid: true,
      daterule: [
        (v) =>
          v == "" ||
          (new Date(v) !== "Invalid Date" && !isNaN(new Date(v))) ||
          "Must be a valid date.",
      ],
      types: ["All", "Traffic", "Warrant", "Dispatch", "Complaint"],
      sterm: {
        frm_date: "None",
        to_date: "None",
        location: "",
        mait: false,
        sro: false,
        accident: false,
        dui: false,
        arrest: false,
        cfs: false,
        cites: false,
        all: true,
        stops: false,
        stop_type: "",
        email: "",
        grant: "",
      },
      new_sterm: {
        frm_date: "None",
        to_date: "None",
        location: "",
        mait: false,
        sro: false,
        accident: false,
        dui: false,
        arrest: false,
        cfs: false,
        cites: false,
        stops: false,
        all: true,
        stop_type: "",
        email: "",
        grant: "",
      },
    };
  },
  watch: {
    update_search_results: {
      deep: true,
      immediate: true,
      handler(val) {
        if (this.bReady_to_update && val != null) {
          this.search();
        }
      },
    },
  },
  computed: {
    hours() {
      var hrs = [];
      hrs.push("None");
      for (let i = 1; i < 24; i++) {
        hrs.push((i * 100).toString().padStart(4, "0"));
      }
      return hrs;
    },
    days() {
      var dys = [];
      dys.push("None");
      for (let i = 0; i < 120; i++) {
        var today = new Date();
        today.setDate(today.getDate() - i);
        var x = this.format_date_us(today);
        dys.push(x);
      }
      return dys;
    },
    d20() {
      var d20 = [];
      for (let index = 0; index < 21; index++) {
        d20.push(index);
      }
      return d20;
    },
    grants() {
      var grants = [];
      for (let index = 0; index < this.lst_grants.length; index++) {
        const element = this.lst_grants[index];
        grants.push(element.grant_name);
      }
      return grants;
    },
  },
  methods: {
    message1() {
      alert("This button does nothing yet.");
    },
    reset() {
      this.sterm = this.mno(this.new_sterm);
      this.$emit("search_clear");
    },
    search() {
      this.show_loader(true);
      this.$emit("search", this.sterm);
      this.$emit("open_search_results");
    },
    init() {
      this.sterm = this.mno(this.new_sterm);
      this.bReady_to_update = true;
      var formIn = {};
      formIn.email = this.$store.state.user.email;
      formIn.token = this.$store.state.user.token;
      formIn.apiname = "get_destinct_s_users";

      var self = this;
      this.$store
        .dispatch("anyapi", formIn)
        .then((data) => {
          this.lst_users = this.mno(data);
          this.lst_email = this.mno(this.lst_users);
          this.values = this.mno(this.lst_users);
        })
        .catch((msg) => {
          self.dialog = false;
          this.show_loader(false);
          this.swall_it("Error lst_users", msg, "error", null, null);
        });
      //getDates_boundry

      var formIn2 = {};
      formIn2.email = this.$store.state.user.email;
      formIn2.token = this.$store.state.user.token;
      formIn2.apiname = "getDates_boundry";
      var self = this;
      this.$store
        .dispatch("anyapi", formIn2)
        .then((data) => {
          // self.mrbreakpoint();
          var date_bndry = { frm_date: data.frm_date, to_date: data.to_date };
          self.$store.commit("set_dates_boundry", self.mno(date_bndry));
        })
        .catch((msg) => {
          self.dialog = false;
          this.show_loader(false);
          this.swall_it("Error lst_users", msg, "error", null, null);
        });
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.init();
    });
  },
};
</script>
